import { render, staticRenderFns } from "./HubblePlotXAxisScaleControlNew.vue?vue&type=template&id=00c7e711&scoped=true"
import script from "./HubblePlotXAxisScaleControlNew.vue?vue&type=script&lang=ts"
export * from "./HubblePlotXAxisScaleControlNew.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlotXAxisScaleControlNew.vue?vue&type=style&index=0&id=00c7e711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c7e711",
  null
  
)

export default component.exports